import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2c61a348"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "menu-title" }, "Available Tutorials", -1))
const _hoisted_3 = { class: "menu-content" }
const _hoisted_4 = {
  key: 0,
  class: "no-tutorials"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-tutorials-icon" }, "📚", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No tutorials available for this page", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "segment-title"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "tutorial-info" }
const _hoisted_11 = { class: "tutorial-name" }
const _hoisted_12 = {
  key: 0,
  class: "tutorial-description"
}
const _hoisted_13 = { class: "tutorial-meta" }
const _hoisted_14 = { class: "tutorial-steps" }
const _hoisted_15 = {
  key: 0,
  class: "tutorial-status active"
}
const _hoisted_16 = { class: "tutorial-actions" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "menu-footer" }

import { computed } from 'vue';
import type { Tutorial, PecTutorConfig } from '../types';

// Props
interface Props {
  tutorials: Tutorial[];
  config: PecTutorConfig;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TutorialMenu',
  props: {
    tutorials: {},
    config: {}
  },
  emits: ["start-tutorial", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

// Computed properties
const menuStyles = computed(() => ({
  borderColor: props.config.theme.primaryColor,
  backgroundColor: props.config.theme.backgroundColor,
  color: props.config.theme.textColor,
}));

const segmentedTutorials = computed(() => {
  const groups: Record<string, Tutorial[]> = {};
  
  // Default unsegmented group
  groups['Geral'] = [];

  props.tutorials.forEach(tutorial => {
    const seg = tutorial.segment || 'Geral';
    if (!groups[seg]) {
      groups[seg] = [];
    }
    groups[seg].push(tutorial);
  });

  // Remove empty groups
  if (groups['Geral'].length === 0) {
    delete groups['Geral'];
  }

  return groups;
});

// Methods
const handleOverlayClick = () => {
  emit('close');
};

const startTutorial = (tutorialId: string) => {
  emit('start-tutorial', tutorialId);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tutorial-menu-overlay",
    onClick: handleOverlayClick
  }, [
    _createElementVNode("div", {
      class: "tutorial-menu",
      style: _normalizeStyle(menuStyles.value),
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          "aria-label": "Close menu"
        }, " × ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.tutorials.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(segmentedTutorials.value, (group, segmentName) => {
          return (_openBlock(), _createElementBlock("div", {
            key: segmentName,
            class: "tutorial-segment"
          }, [
            (Object.keys(segmentedTutorials.value).length > 1 || segmentName !== 'Geral')
              ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(segmentName), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (tutorial) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tutorial.id,
                class: _normalizeClass(["tutorial-item", { 'tutorial-active': tutorial.isActive }]),
                onClick: ($event: any) => (startTutorial(tutorial.id))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("h5", _hoisted_11, _toDisplayString(tutorial.name), 1),
                  (tutorial.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(tutorial.description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(tutorial.steps?.length || 0) + " steps ", 1),
                    (tutorial.isActive)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " In Progress "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    class: "btn btn-primary btn-small",
                    onClick: _withModifiers(($event: any) => (startTutorial(tutorial.id)), ["stop"])
                  }, _toDisplayString(tutorial.isActive ? 'Continue' : 'Start'), 9, _hoisted_17)
                ])
              ], 10, _hoisted_9))
            }), 128))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "btn btn-secondary btn-small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, " Close ")
      ])
    ], 4)
  ]))
}
}

})